import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ApiResponseEmpty } from '../../../types';
import { MyProfileForm } from '../components/subforms/validation/profile.validation';
import { API_IDENTITY } from '../../../api/api.base';
import { QueryKeys } from '../../../constants';
import { Alerter } from '../../../utils';

export const useEditCurrentUser = () => {
	const queryClient = useQueryClient();

	return useMutation<ApiResponseEmpty, unknown, MyProfileForm>({
		mutationFn: data => API_IDENTITY.post('/api/user/current/edit', data),
		onSuccess(e) {
			queryClient.invalidateQueries({
				queryKey: [QueryKeys.CURRENT_USER],
			});
			Alerter.success(e.messages[0]?.message);
		},
		onError(e) {
			Alerter.error(e as string);
		},
	});
};
